import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { ListPanel } from '@eika/link-panel';

import piwik from '@/piwik/piwik';
import { useAccountFromAccountId } from '@/react-query/hooks/query/use-account';

import { Card } from '@generated-types';
import useText from '@hooks/use-text';
import { isDebitAccount } from '@utils/account-utils';

interface TransactionsProps {
    card: Card;
}

const Transactions = ({ card }: TransactionsProps) => {
    const text = useText();
    const accountQuery = useAccountFromAccountId(card);
    const url = isDebitAccount(accountQuery.data)
        ? `${text.transactionAccountUrlPath}?${text.transactionAccountUrlParamId}=${accountQuery.data.externalId}`
        : null;

    if (!accountQuery.data?.allowedOperations.accessTransactions || !url) {
        return null;
    }

    return (
        <ListPanel
            url={url}
            prefixContent={<Icon type={IconTypes.BEVEGELSER_24} />}
            title={text.transactionsTitle}
            icon={IconTypes.PIL_HOEYRE}
            backgroundColor="light"
            id="link-transactions"
            data-track-id={piwik.cardDetails.cardFunctionalityLinkTransaksjoner.dataTrackId}
            data-track-linkname={piwik.cardDetails.cardFunctionalityLinkTransaksjoner.dataTrackLinkname}
        />
    );
};

export default Transactions;
